<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppShell from './components/layout/AppShell.vue'

const route = useRoute()
const isFullscreen = computed(() => route.meta.fullscreen === true)
</script>

<template>
  <AppShell v-if="!isFullscreen" />
  <router-view v-else />
</template>

<style>
#app {
  height: 100vh;
  font-family: var(--aw-font-sans);
  color: var(--aw-text-primary);
  background-color: var(--aw-bg-base);
}
</style>
